import React from "react";
import InquiryTable from "../components/InquiryTable";
import "../style/admin-inquiry-page.css";
import Bg from "../assets/faq-bg.png";
import { useNavigate } from "react-router-dom";
import {useAdmin} from "../utils/AdminContext";


const AdminInquiryPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAdmin } = useAdmin();

  if (!isAdmin) {
    return <div>접근 권한이 없습니다.</div>;
  }

  return (
    <div className="admin-inquiry-page">
      <img className="admin-inquiry-bg" src={Bg} alt="" />
      <div
        className="admin-inquiry-page-title-2"
        onClick={() => navigate("/admin")}
      >
        ADMIN
      </div>
      <h1>실시간 문의 확인</h1>
      <InquiryTable />
    </div>
  );
};

export default AdminInquiryPage;
